import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';
import { EnvironmentconfigService } from '../../shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DateUtil } from 'src/app/shared/utils/date-format.util';
import { BaseComponent } from '../../shared/base/base.component';
import { MatomoTracker } from 'ngx-matomo';
import { LayoutComponent } from 'src/app/layout/layout.component';

@Component({
  selector: 'app-wmsm-ChangeHistory',
  templateUrl: './wmsm-ChangeHistory.component.html',
  styleUrls: ['./wmsm-ChangeHistory.component.scss']
})
export class WmsmChangeHistoryComponent extends BaseComponent implements OnInit {
  loading: boolean = false;
  isShowCondition: boolean = true;
  // 表格每页显示条数,默认每頁顯示10筆資料
  pageSize: number = 20;
  // 表格页码
  pageIndex: number = 1;
  nzTotal: number = 0;
  listOfData: any[] = [];
  validateForm: FormGroup;
  UploadvalidateForm: FormGroup;
  RenamevalidateForm: FormGroup;
  SiteList: any;
  LastSite: string;
  LastPONO: string;
  formValues: any;
  constructor(
    private fb: FormBuilder,
    private AuthService: AuthService,
    private Environment: EnvironmentconfigService,
    private WebApiService: WebApiService,
    private NzMessageService: NzMessageService,
    private matomotracker: MatomoTracker,
    private LayoutComponent: LayoutComponent,
  ) { super() }

  ngOnInit() {
    this.validateForm = this.fb.group({
      PONO: [''],
    });
    this.matomotracker.trackPageView("交期互動管理")
    this.matomotracker.trackEvent("交期互動管理", "交期變更歷程", "view", 1);
    this.LayoutComponent.geturl()
  }
  getFormValue(value) {
    this.formValues = value;
  }

  getQuery(value) {
    this.isShowCondition = value;
  }

  onSearch() {
    this.isShowCondition = !this.isShowCondition;
    this.getResultData();
  }
  getResultData() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DeliveryDateChangeProcessQuery.url}`;
    const startDate = this.formValues.POApprovedate.length !== 0 ? this.formValues.POApprovedate[0] : '';
    let endDate = '';
    if (this.formValues.POApprovedate.length !== 0) {
      const endDateObj = new Date(this.formValues.POApprovedate[1]);
      endDateObj.setDate(endDateObj.getDate() + 1);
      endDate = endDateObj.toISOString().split('T')[0];
    }
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        SiteNo: this.formValues.Site,
        //Pono: this.validateForm.controls['PONO'].value || '',
        Pono: this.formValues.PONO,
        Language: sessionStorage.getItem("wmsmlang"),
        Buyer: this.formValues.Buyer,
        Prno: this.formValues.PRNO,
        vendorCode: this.formValues.Vendor,
        Category: this.formValues.Type,
        StatementMonthFrom: this.getTheDateString_(startDate) || '',
        StatementMonthTo: this.getTheDateString_(endDate) || '',
        type: '', //後端會重取
        RTorNot: this.formValues.RTorNot,
      },
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (res && res.status == this.Environment.authConfig.wmsmStatus) {
          this.LastSite = this.formValues.Site;
          this.LastPONO = this.validateForm.controls['PONO'].value;
          this.listOfData = res.data
          // .map((item) => {
          //   item.changeDate = DateUtil.formatYMD(item.changeDate);
          //   return item;
          // });
          this.nzTotal = res.total;
          this.NzMessageService.success(res.msg);
        } else {
          this.listOfData = [];
          this.nzTotal = 0;
          this.NzMessageService.warning(res.msg);
        }
        this.loading = false;
      },
      (error) => {
        this.NzMessageService.error(error.msg);
      }
    );
  }
  exportTableToExecl() {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.DownLoadDeliveryDateChangeProcessQueryExcel.url}`;
    const startDate = this.formValues.POApprovedate.length !== 0 ? this.formValues.POApprovedate[0] : '';
    let endDate = '';
    if (this.formValues.POApprovedate.length !== 0) {
      const endDateObj = new Date(this.formValues.POApprovedate[1]);
      endDateObj.setDate(endDateObj.getDate() + 1);
      endDate = endDateObj.toISOString().split('T')[0];
    }
    const params = {
      data: {
        SiteNo: this.LastSite ? this.LastSite : this.formValues.Site,
        Pono: this.formValues.PONO,
        Language: sessionStorage.getItem("wmsmlang"),
        Buyer: this.formValues.Buyer,
        Prno: this.formValues.PRNO,
        vendorCode: this.formValues.Vendor,
        Category: this.formValues.Type,
        StatementMonthFrom: this.getTheDateString_(startDate) || '',
        StatementMonthTo: this.getTheDateString_(endDate) || '',
        type: '', //後端會重取
        RTorNot: this.formValues.RTorNot,
      },
    };
    this.WebApiService.doPost(url, params, true).subscribe((res) => {
      this.downloadFile8(res, `Change_History_${this.getTimeString()}.xlsx`);
      this.loading = false;
    });
  }
  // 切换每页数据条数
  nzPageSizeChange(event: number): void {
    if (this.nzTotal === 0) {
      return;
    }
    this.pageSize = event;
    if (event * this.pageIndex > this.nzTotal && this.pageIndex > 1) {
      this.pageIndex--;
    }
    this.getResultData();
  }
  // 切换页码
  nzPageIndexChange(event: number): void {
    this.pageIndex = event;
    this.getResultData();
  }

  onQueryClick(): string {
    return 'ChangeHistory';
  }


  sortChange(e) {
    this.listOfData = e === 'ascend' ? this.listOfData.sort(
      (a, b) => a.pono.localeCompare(b.pono)
    ) : this.listOfData.sort(
      (a, b) => b.pono.localeCompare(a.pono)
    )
  }

}
